import { styled } from '@mui/system';
import { MaterialDesignContent } from 'notistack';

const StyledMaterialDesignContent = styled(MaterialDesignContent)(
  ({ theme }) => ({
    '&.notistack-MuiContent-success': {
      backgroundColor: theme.palette.success.main,
    },
    '&.notistack-MuiContent-error': {
      backgroundColor: theme.palette.error.main,
    },
    '&.notistack-MuiContent-warning': {
      backgroundColor: theme.palette.warning.main,
    },
    '&.notistack-MuiContent-info': {
      backgroundColor: theme.palette.info.main,
    },
    '&.notistack-MuiContent-root': {
      backgroundColor: theme.palette.primary.main,
    },
  }),
);

export const stylesProvider = {
  success: StyledMaterialDesignContent,
  error: StyledMaterialDesignContent,
  warning: StyledMaterialDesignContent,
  info: StyledMaterialDesignContent,
  default: StyledMaterialDesignContent,
};
